import { schema } from "normalizr";
import { ImageSchema } from "main/javascripts/schemas/ImageSchema";

export const HotelSchema: schema.Entity = new schema.Entity("hotel", {
  images: [ImageSchema],
});

export const HotelsSchema: schema.Object = new schema.Object({
  hotels: [HotelSchema],
});

export const HotelForMapSchema: schema.Entity = new schema.Entity(
  "hotelForMap",
  { images: [ImageSchema] }
);

export const HotelsForMapSchema: schema.Object = new schema.Object({
  hotels: [HotelForMapSchema],
});
